import { render, staticRenderFns } from "./ServidorDependentes.vue?vue&type=template&id=4d97e607"
import script from "./ServidorDependentes.vue?vue&type=script&lang=js"
export * from "./ServidorDependentes.vue?vue&type=script&lang=js"
import style0 from "./ServidorDependentes.vue?vue&type=style&index=0&id=4d97e607&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports